import { apiClient } from '../client'
import type {
  MedicalDeviceBrand,
  MedicalDeviceBrandFilter,
  MedicalDeviceClassificationCatalog,
  UpsertMedicalDeviceBrandRequest,
  UpsertMedicalDeviceClassificationCatalogRequest,
  Supplier,
  UpsertSupplierRequest,
} from '../types/basic-information'

const basePath = '/api/basic-information'

export function getMedicalDeviceBrands(filter: MedicalDeviceBrandFilter = {}) {
  const search = new URLSearchParams()
  if (filter.keyword) search.set('keyword', filter.keyword)
  if (filter.origin) search.set('origin', filter.origin)
  const suffix = search.size ? `?${search.toString()}` : ''
  return apiClient.get<MedicalDeviceBrand[]>(`${basePath}/medical-device-brands${suffix}`)
}

export function createMedicalDeviceBrand(data: UpsertMedicalDeviceBrandRequest) {
  return apiClient.post<MedicalDeviceBrand>(`${basePath}/medical-device-brands`, data)
}

export function updateMedicalDeviceBrand(id: number, data: UpsertMedicalDeviceBrandRequest) {
  return apiClient.put<MedicalDeviceBrand>(`${basePath}/medical-device-brands/${id}`, data)
}

export function deleteMedicalDeviceBrand(id: number) {
  return apiClient.delete<void>(`${basePath}/medical-device-brands/${id}`)
}

export function getMedicalDeviceCatalogTree() {
  return apiClient.get<MedicalDeviceClassificationCatalog[]>(`${basePath}/medical-device-classification-catalogs`)
}

export function createMedicalDeviceCatalog(data: UpsertMedicalDeviceClassificationCatalogRequest) {
  return apiClient.post<MedicalDeviceClassificationCatalog>(`${basePath}/medical-device-classification-catalogs`, data)
}

export function updateMedicalDeviceCatalog(id: number, data: UpsertMedicalDeviceClassificationCatalogRequest) {
  return apiClient.put<MedicalDeviceClassificationCatalog>(`${basePath}/medical-device-classification-catalogs/${id}`, data)
}

export function deleteMedicalDeviceCatalog(id: number) {
  return apiClient.delete<void>(`${basePath}/medical-device-classification-catalogs/${id}`)
}

export function getSuppliers(keyword?: string) {
  const suffix = keyword ? `?keyword=${encodeURIComponent(keyword)}` : ''
  return apiClient.get<Supplier[]>(`${basePath}/suppliers${suffix}`)
}

export function createSupplier(data: UpsertSupplierRequest) {
  return apiClient.post<Supplier>(`${basePath}/suppliers`, data)
}

export function updateSupplier(id: number, data: UpsertSupplierRequest) {
  return apiClient.put<Supplier>(`${basePath}/suppliers/${id}`, data)
}

export function deleteSupplier(id: number) {
  return apiClient.delete<void>(`${basePath}/suppliers/${id}`)
}
